import * as z from 'zod';

const EnvSchema = z.object({
  API_URL: z.string(),
  API_V3_URL: z.string(),
  FIREBASE_API_KEY: z.string(),
  FIREBASE_AUTH_DOMAIN: z.string(),
  FIREBASE_PROJECT_ID: z.string(),
  FIREBASE_STORAGE_BUCKET: z.string(),
  FIREBASE_MESSAGING_SENDER_ID: z.string(),
  FIREBASE_APP_ID: z.string(),
  FIREBASE_MEASUREMENT_ID: z.string().optional(),
  WORKSPACE_ID: z.string().optional(),
  SENTRY_DSN: z.string().optional(),
  MIXPANEL_TOKEN: z.string().optional(),
  ENABLE_API_MOCKING: z
    .string()
    .refine((s) => s === 'true' || s === 'false')
    .transform((s) => s === 'true')
    .optional(),
});

const envVars = Object.entries(import.meta.env).reduce<Record<string, string>>(
  (acc, curr) => {
    const [key, value] = curr;
    if (key.startsWith('VITE_APP_')) {
      acc[key.replace('VITE_APP_', '')] = value;
    }
    return acc;
  },
  {},
);

const parsedEnv = EnvSchema.safeParse(envVars);

if (!parsedEnv.success) {
  throw new Error(
    `Invalid env provided.\nThe following variables are missing or invalid:\n${Object.entries(
      parsedEnv.error.flatten().fieldErrors,
    )
      .map(([k, v]) => `- ${k}: ${v}`)
      .join('\n')}`,
  );
}

export const env = parsedEnv.data;
